import React from "react";
import PropTypes from "prop-types";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Portlet } from "@domestika-dev/prudencio/dist/atoms/Portlet";
import { DomestikaLiveLogo } from "@domestika-dev/prudencio/dist/atoms/DomestikaLiveLogo";
import { HeaderLeaveButton } from "./HeaderLeaveButton";

export const HeaderContent = ({ showLeaveButton, headerRef }) => (
  <div ref={headerRef}>
    <Portlet paddingX={5} paddingY={3}>
      <Grid gridRowGap={[0, 4, 4]} gridTemplateColumns="1fr 1fr" style={{ alignItems: "center" }}>
        <GridItem gridColumn="1" gridRow="1">
          <DomestikaLiveLogo
            width={["190px", "190px", "190px"]}
            height={["27px", "27px", "27px"]}
          />
        </GridItem>
        {showLeaveButton && (
          <GridItem gridColumn="8" gridRow="1">
            <HeaderLeaveButton />
          </GridItem>
        )}
      </Grid>
    </Portlet>
  </div>
);

HeaderContent.propTypes = {
  showLeaveButton: PropTypes.bool,
  headerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.elementType }),
  ]),
};

HeaderContent.defaultProps = {
  showLeaveButton: false,
  headerRef: null,
};

export default HeaderContent;
